<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-card-title class="primary white--text">
        Xóa học sinh tại điểm dừng "{{ busStop.address }}"
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="text-h6 mt-4 mb-2 font-weight-bold">
          Danh sách học sinh
        </div>
        <v-card outlined class="elevation-0">
          <div class="d-flex align-center justify-space-between px-6 py-4" v-if="selecteds && selecteds.length">
            <div class="d-flex flex-column">
              <span>
                {{ 'Đã chọn ' + selecteds.length + ' học sinh' }}
              </span>
            </div>
          </div>
          <v-data-table
            showSelect
            v-model="selecteds"
            :headers="headers"
            :items="busStop.students"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:[`item.name`]="{ item }">
              <CardStudentName :student="item" link />
            </template>
            <template v-slot:[`item.dob`]="{ item }">
              <span>{{ item.dob | ddmmyyyy }}</span>
            </template>
            <template v-slot:[`item.classes`]="{ item }">
              <router-link style="text-decoration: none" :to="'/class/' + (item.currentClass && item.currentClass.id)">
                <span v-if="item.currentClass">{{ item.currentClass && item.currentClass.title }}</span>
              </router-link>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4 px-6">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="confirmRemove">XÁC NHẬN XÓA</v-btn>
      </v-card-actions>
    </v-card>

    <BusStopUpdateStudentConfirmDialog
      :state="confirmDialog"
      :busStop="busStop"
      :removeStudents="selecteds"
      @done="dialog = false"
    />
  </v-dialog>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import BusStopUpdateStudentConfirmDialog from '@/modules/bus/BusStopUpdateStudentConfirmDialog.vue'

export default {
  components: {
    CardStudentName,
    BusStopUpdateStudentConfirmDialog
  },
  data() {
    return {
      selecteds: [],
      dialog: false,
      confirmDialog: false,
      headers: [
        {
          text: 'Học sinh',
          value: 'name',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Ngày sinh',
          value: 'dob',
          align: 'left',
          sortable: false,
          show: true
        },
        { text: 'Lớp', value: 'classes', align: 'left', sortable: false, show: true }
      ]
    }
  },
  props: {
    state: Boolean,
    busStop: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  methods: {
    cancel() {
      this.dialog = false
      this.selecteds = []
    },
    confirmRemove() {
      if (!this.selecteds || !this.selecteds.length) {
        this.$alert.error('Chưa chọn học sinh')
        return
      }
      this.confirmDialog = !this.confirmDialog
    }
  },
  watch: {
    state() {
      this.dialog = true
    }
  }
}
</script>
